document.addEventListener('DOMContentLoaded', () => {
  const setAppHeight = () => {
    document.documentElement.style.setProperty('--kova-viewport-height', `${window.innerHeight}px`)
  }

  window.addEventListener('resize', setAppHeight)
  setAppHeight()
})